import { MessageBusInternalHubEvent } from '@brightside-web/micro/core/message-bus';

export interface DisplayData {
  cta?: string;
  ctaKey?: string;
  ctaEvent?: MessageBusInternalHubEvent;
  ctaPath: string;
  image: string;
  key: string;
  secondaryCta?: string;
  secondaryCtaKey?: string;
  secondaryCtaEvent?: MessageBusInternalHubEvent;
  secondaryCtaPath?: string;
  textBody?: string;
  textBodyKey?: string;
  title?: string;
  titleKey?: string;
  textBodyAlign?: 'center' | 'left' | 'right'
  textBodyNoWrap?: boolean;
  isCreditIntro?: boolean;
  ctaFunction?: () => void;
  showBackButton?: boolean;
  backFunction?: () => void;
}

export enum CampaignEventStatus {
  SKIPPED = 'skipped',
  SUCCESS = 'success',
  FAILED = 'failed',
  NEUTRAL = 'neutral',
}
